import React from 'react';
import PropTypes from 'prop-types';
import { types } from '../../../../../../../_constants/product/types';
import getTranslatedText from '../../../../../../helper/get_translated_text';

function LightboxDefaultAction({ onApplyClick, onResetAndCloseClick, productType, isDisabled }) {

    const translateCTAOnProductType = productType === types.WHEEL ? 'catalog-filter-lightbox-wheels-apply-button'
        : 'catalog-filter-lightbox-apply-button';
    return (
        <div className="lightbox-filter-view__actions-section lightbox-filters-actions">
            <button
                className="lightbox-filters-actions__action lightbox-filters-actions__reset-close"
                onClick={onResetAndCloseClick}
            >
                {getTranslatedText('catalog-filter-lightbox-reset-close-button')}
            </button>

            <button
                className="lightbox-filters-actions__action lightbox-filters-actions__apply"
                onClick={onApplyClick}
                disabled={isDisabled}
            >
                {getTranslatedText(translateCTAOnProductType)}
            </button>
        </div>
    );
}

LightboxDefaultAction.propTypes = {
    onApplyClick: PropTypes.func.isRequired,
    onResetAndCloseClick: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    productType: PropTypes.string.isRequired,
};

export { LightboxDefaultAction };
